export default (elem) => {
	let index = 0;
	let el = elem;

	while (el.previousElementSibling) {
		index++;
		el = el.previousElementSibling;
	}

	return index;
}
